import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { useState as n, useEffect as t } from "react";
function a(n, t, a, e) {
  return new (a || (a = Promise))(function (i, c) {
    function o(n) {
      try {
        l(e.next(n));
      } catch (n) {
        c(n);
      }
    }
    function s(n) {
      try {
        l(e.throw(n));
      } catch (n) {
        c(n);
      }
    }
    function l(n) {
      var t;
      n.done ? i(n.value) : (t = n.value, t instanceof a ? t : new a(function (n) {
        n(t);
      })).then(o, s);
    }
    l((e = e.apply(n, t || [])).next());
  });
}
var e = function e(_ref) {
  var e = _ref.initialValues,
    i = _ref.callback,
    c = _ref.validate,
    o = _ref.validateOnChange;
  var _n = n(e),
    _n2 = _slicedToArray(_n, 2),
    s = _n2[0],
    l = _n2[1],
    _n3 = n({}),
    _n4 = _slicedToArray(_n3, 2),
    r = _n4[0],
    v = _n4[1],
    _n5 = n(!1),
    _n6 = _slicedToArray(_n5, 2),
    u = _n6[0],
    d = _n6[1],
    _n7 = n(!1),
    _n8 = _slicedToArray(_n7, 2),
    g = _n8[0],
    b = _n8[1];
  t(function () {
    r.valid && u && i(s), d(!1);
  }, [r]);
  return {
    handleChange: function handleChange(n) {
      return a(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var t, a, _n9;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = "", a = "";
                if (!(n.target ? (t = n.target.name, a = n.target.value) : (t = n.name, a = n.value), l(function (n) {
                  return Object.assign(Object.assign({}, n), _defineProperty({}, t, a));
                }), o && g)) {
                  _context.next = 6;
                  break;
                }
                _context.next = 4;
                return c(Object.assign(Object.assign({}, s), _defineProperty({}, t, a)));
              case 4:
                _n9 = _context.sent;
                v(function (t) {
                  return Object.assign(Object.assign(Object.assign({}, t), _n9), {
                    validation: Object.assign(Object.assign({}, t.validation), _n9.validation)
                  });
                });
              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    },
    handleSubmit: function handleSubmit(n) {
      return a(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                n && n.preventDefault();
                d(!0);
                b(!0);
                _context2.t0 = v;
                _context2.next = 6;
                return c(Object.assign({}, s));
              case 6:
                _context2.t1 = _context2.sent;
                (0, _context2.t0)(_context2.t1);
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
    },
    values: s,
    errors: r
  };
};
export { e as useForm };